import { useState } from "react";
import { back } from "../Api/ApiUrl";
import instance from "../Api/Instance";

export default function useDataLogger() {
  const [isValidDataLogger, setIsValidDataLogger] = useState(false);
  const checkValidDataLogger = async (dataLoggerId, materialType = 2) => {
    setIsValidDataLogger(false);
    try {
      const response = await instance.get(
        `${back.getImeiInfo}/${dataLoggerId}?materialType=${materialType}`
      );

      if (response?.status === 200) {
        setIsValidDataLogger(true);
        return response?.data;
      }
      return false;
    } catch (error) {
      console.error(error);
      setIsValidDataLogger(false);
      return false;
    }
  };

  return { checkValidDataLogger, isValidDataLogger };
}
